import React, { useEffect } from 'react';
import axios from 'axios';

function PrintOrderButton() {
  const orderDetails = {
    orderId: 'ORD123456',
    customerName: 'John Doe',
    items: [
      { name: 'Chicken Biryani', qty: 2, price: 12.99 },
      { name: 'Paneer Butter Masala', qty: 1, price: 10.50 },
      { name: 'Garlic Naan', qty: 4, price: 2.00 },
      { name: 'Tandoori Chicken', qty: 1, price: 14.00 },
      { name: 'Veg Pulao', qty: 1, price: 9.99 },
      { name: 'Mango Lassi', qty: 2, price: 4.50 },
    ],
    totalAmount: 74.48
  };

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        await axios.post('http://localhost:5000/api/print', [
          { order: orderDetails }
        ]);
        console.log('Order sent to printer');
      } catch (err) {
        console.error('Printing failed', err);
        alert('Printing failed');
      }
    }, 3000);

    return () => clearTimeout(timer); // cleanup if component unmounts before 3s
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>Preparing to Print Order...</h2>
      <p>Printing will start automatically in 3 seconds.</p>
    </div>
  );
}

export default PrintOrderButton;
